import Page from 'src/apipages/enterprise/index';

export default Page;
